import React, { useEffect, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Header } from './header'
import { SelectWithLabelInput } from '../../Atoms/Inputs/SelectWithLabel'
import { TextInput } from '../../Atoms/Inputs/Text'
import { useParams } from 'react-router-dom'
import { getEntityVersionById } from '../../../store/common/api'
import { handleError } from '../../../utils/handleErrors'
import { formatDate } from '../../../Services/dateFormat'
import Table from '../../Organisms/Tables/Table/Table'
import { ParameterHistoryChangesPopup } from './ParameterHistoryChangesPopup'
import { getParametersByDataModelId } from '../../../store/parameter/api'
import { CreateVariableFields } from './CreateVariableFields'
import { CreateEntitiesFields } from './CreateEntitiesFields'

const entityType = 'parameter'
const entityURL = 'parameters'
const GROUPS = [
    { name: 'Client Characteristics', value: 1 },
    { name: 'Creditworthiness', value: 2 },
    { name: 'Product Class Characteristics', value: 3 },
    { name: 'Solvency', value: 4 },
    { name: 'Expense analysis', value: 5 },
    { name: 'Income analysis', value: 6 },
    { name: 'Limit level', value: 7 },
    { name: 'Limits', value: 8 },
    { name: 'Decision making', value: 9 },
    { name: 'Term of sales', value: 10 },
    { name: 'Global', value: 11 },
    { name: 'Cross Sale', value: 12 },
]
export const Parameter = () => {
    const { id } = useParams()
    const [entity, setEntity] = useState({ type: 1 })
    const [versions, setVersions] = useState([])
    const [globalParameters, setGlobalParameters] = useState([])
    const [parameters, setParameters] = useState([])
    const [openRowPopup, setOpenRowPopup] = useState(null)
    const versionTableHeaders = [
        {
            headerName: 'Version',
            field: 'version',
            filter: true,
            sort: true,
        },
        {
            headerName: 'Created By',
            field: 'createdBy',
            filter: true,
            sort: true,
        },
        {
            headerName: 'Created At',
            field: 'createdAt',
            filter: true,
            sort: true,
            valueGetter: (params) => {
                return formatDate(new Date(params.data.createdAt))
            },
        },
        {
            headerName: 'Approver',
            field: 'createdBy',
            filter: true,
            sort: true,
        },
        {
            field: 'Actions',
            filter: false,
            sort: false,
            cellRenderer: (params) => {
                return (
                    <span
                        onClick={() => setOpenRowPopup(params.data.id)}
                        style={{ color: 'rgb(0 198 162 / 69%)' }}
                    >
                        View
                    </span>
                )
            },
        },
    ]

    const TYPES = [
        { name: 'Variable', value: 1 },
        { name: 'Script', value: 2 },
        { name: 'Value Setter', value: 3 },
        { name: 'Score Card', value: 4 },
    ]

    const updateInfo = (id) => {
        getEntityVersionById(id, entityType)
            .then((versions) => {
                if (versions && versions.length > 0) {
                    setEntity(versions[0])
                }
            })
            .catch(handleError)
    }

    useEffect(() => {
        updateInfo(id)
    }, [])
    useEffect(() => {
        if (entity?.modelId) {
            getParametersByDataModelId({ modelId: entity.modelId }, []).then(
                (_parameters) => {
                    const list1 = _parameters
                        .filter((item) => item.group === 11 && item.type == 1)
                        .map((item) => {
                            return { label: item.name, value: item._id }
                        })
                    setGlobalParameters(list1)
                    const list2 = _parameters
                        .filter((item) => item.type === 1)
                        .map((item) => {
                            return { label: item.name, value: item._id }
                        })
                    setParameters(list2)
                },
            )
        }
    }, [entity.modelId])

    const onEntityChange = (key, body) => {
        setEntity({
            ...entity,
            [key]: body,
        })
    }

    return (
        <>
            <ToastContainer />
            <div className="rightSide">
                <div className="codeWrapper">
                    <Header
                        updateInfo={updateInfo}
                        entity={entity}
                        entityURL={entityURL}
                    />
                    {openRowPopup ? (
                        <ParameterHistoryChangesPopup
                            id={openRowPopup}
                            close={() => setOpenRowPopup(null)}
                        />
                    ) : null}
                    <div className="single-table-wrapper parameter-content parameter-individual-page">
                        <div className="inputsWrapper">
                            <div className="row">
                                <TextInput
                                    label="Name"
                                    value={entity.name}
                                    onChange={({ target }) => {
                                        onEntityChange('name', target.value)
                                    }}
                                    placeholder="Name"
                                />
                            </div>
                            <div className="row">
                                <SelectWithLabelInput
                                    label="Group"
                                    defaultValue={entity.group}
                                    onChange={({ target }) => {
                                        onEntityChange('group', target.value)
                                    }}
                                    options={GROUPS}
                                />
                            </div>
                            <div className="row">
                                <SelectWithLabelInput
                                    label="Type"
                                    defaultValue={entity?.type}
                                    onChange={({ target }) => {
                                        onEntityChange('type', target.value)
                                    }}
                                    options={TYPES}
                                />
                            </div>
                            {entity.type == 1 ? (
                                <CreateVariableFields
                                    entity={entity}
                                    onEntityChange={onEntityChange}
                                />
                            ) : (
                                <CreateEntitiesFields
                                    entity={entity}
                                    globalParameters={globalParameters}
                                    parameters={parameters}
                                    onEntityChange={onEntityChange}
                                />
                            )}
                            <div className="row">
                                <label className="formInput">
                                    Description
                                    <textarea
                                        value={entity.description}
                                        onChange={({ target }) => {
                                            onEntityChange(
                                                'description',
                                                target.value,
                                            )
                                        }}
                                        placeholder="Description"
                                        style={{
                                            width: '100%',
                                            borderRadius: '7px',
                                            marginTop: '7px',
                                            height: 'calc(100vh - 600px)',
                                        }}
                                        cols="25"
                                    />
                                </label>
                            </div>
                        </div>
                        <div className="historyWrapper">
                            <div className="title">
                                <span>History</span>
                                <div className="wrapper">
                                    <Table
                                        column={versionTableHeaders}
                                        id={window.location.pathname}
                                        data={versions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
